import ERRORS from '../errors/errorids';
const SMALL_BREAKPOINT_NAME_WIDTH = 150;

export const getTableStyleProps = (theme) => {
	
	return {
		/* no users message */
		noUsersFound: {
			width: '100%',
			textAlign: 'center'
		},

		/* table */
		table: {
			tableLayout: 'fixed'
		},
		tableHeadRow: {
			backgroundColor: '#F4F4F4'
		},
		tableBodyRow: {
			'&:nth-of-type(even)': {
				backgroundColor: '#F4F4F4',
			},
			'&:hover': {
				backgroundColor: '#e8e8e8 !important'
			}
		},
		tableCellHeader: {
			fontSize: 14
		},
		tableNameCellHeader: {
			width: 375,
			[theme.breakpoints.down('sm')]: {
				width: SMALL_BREAKPOINT_NAME_WIDTH
			}
		},
		tableIdCellHeader: {
		},
		tableCellBody: {
			fontSize: 14,
			paddingTop: 27,
			paddingBottom: 27
		},
		tableNameCellBody: {
		},
		tableIdCellBody: {
		},		
		tableActionsCell: {
			width: 40,
			textAlign: 'right',
			alignItems: 'center',
			'& .errorMessage': {
				width: 200,
				whiteSpace: 'wrap',
				marginTop: 10,
				textAlign: 'left',
				[theme.breakpoints.down('sm')]: {
					width: 120,
				}				
			}
		},
		noBorderedCell: {
		}
	};
};

export const MLS_ERRORS = {
	[ERRORS.OFFLINE]: 'mls-error-offline',
	[ERRORS.UNKNOWN]: 'mls-error-unknown',

	[ERRORS.AGENT_INTERNAL_SERVER_ERROR]: 'mls-error-internal-server-error',
	[ERRORS.AGENT_CONNECTION_NOT_FOUND]: 'mls-error-connection-not-found',
	[ERRORS.AGENT_ID_EXISTS]: 'mls-error-agent-mls-id-already-assigned',
	[ERRORS.AGENT_NOT_FOUND]: 'mls-error-agent-not-found',
	[ERRORS.API_KEY_REQUIRED]: 'mls-error-api-key-required',
	[ERRORS.INVALID_CONNECTION_ID]: 'mls-error-invalid-connection-id',
	[ERRORS.AGENT_INVALID_COMPANY_ID]: 'mls-error-invalid-company-id',
	[ERRORS.FAILED_TO_LIST_AGENTS]: 'mls-error-failed-to-list-agents',
	[ERRORS.INVALID_ADD_AGENT_MLS_ID_PACKET]: 'mls-error-invalid-add-agent-packet',
	[ERRORS.INVALID_DELETE_AGENT_MLS_ID_PACKET]: 'mls-error-invalid-delete-agent-packet',
	[ERRORS.INVALID_EDIT_AGENT_MLS_ID_PACKET]: 'mls-error-invalid-edit-agent-packet',	
	[ERRORS.MLS_NO_LISTINGS_FOUND]: 'mls-popup-no-listings-found',	
	[ERRORS.INVALID_DELETE_CONNECTION_PACKET]: 'mls-error-invalid-delete-connection-packet',
	[ERRORS.INVALID_DELETE_OFFICE_ID_PACKET]: 'mls-error-invalid-delete-office-packet',
	[ERRORS.INVALID_AGENT_ID]: 'mls-error-invalid-agent-id-format',
	[ERRORS.TOO_MANY_ATTEMPTS]: 'mls-error-rate-limit-reached',
	[ERRORS.AGENT_NO_LISTINGS_FOUND]: 'mls-popup-no-listings-found-for-agent',
	[ERRORS.EMAIL_NOT_VERIFIED]: 'mls-error-email-not-verified',
	[ERRORS.SUBSCRIPTION_NEEDED]: 'mls-error-subscription-needed',
	[ERRORS.MAX_CONNECTIONS_EXCEEDED]: 'mls-error-connection-limit-reached',
	[ERRORS.INVALID_MLS_BOARD_CODE]: 'mls-error-invalid-mls-board-name',
	[ERRORS.MLS_COMPANY_NOT_FOUND]: 'mls-error-company-not-found',
	[ERRORS.INVALID_ADD_CONNECTION_WITH_OFFICE_ID_PACKET]: 'mls-error-invalid-add-connection-with-office-id-packet',
	[ERRORS.INVALID_ADD_CONNECTION_WITH_AGENT_ID_PACKET]: 'mls-error-invalid-add-connection-with-agent-id-packet',
	[ERRORS.INVALID_ADD_OFFICE_ID_PACKET]: 'mls-error-invalid-add-office-to-connection-packet',	
	[ERRORS.MLS_INTERNAL_SERVER_ERROR]: 'mls-error-internal-server-error',
	[ERRORS.USER_SESSION_INVALID]: 'mls-error-invalid-user-session',
	[ERRORS.MLS_CONNECTION_NOT_FOUND]: 'mls-error-connection-not-found',
	[ERRORS.OFFICE_NOT_FOUND]: 'mls-error-office-not-found',

	// REAL ESTATE API related
	[ERRORS.INVALID_MLS_CONNECTION_CONFIG]: 're-api-error-invalid-mls-connection-config',
	[ERRORS.INVALID_OFFICE_ID]: 're-api-error-invalid-office-id',
	[ERRORS.INVALID_AGENT_CODE]: 're-api-error-invalid-agent-code',
	[ERRORS.INVALID_API_KEY]: 're-api-error-invalid-api-key',
	[ERRORS.RE_API_INTERNAL_SERVER_ERROR]: 're-api-error-re-api-internal-server-error',

	// NEW HTTP SERVICE RELATED
	[ERRORS.HTTP_INTERNAL_SERVER_ERROR]: 'http-error-internal-server-error',
	[ERRORS.HTTP_MISSING_COMPANY_ID]: 'http-error-mising-company-id',
	[ERRORS.HTTP_MISSING_USER_ID]: 'http-error-missing-user-id'
};


// WEBPACK FOOTER //
// ./src/utils/mls.js